import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, defaultPercentField } from "helpers/row-logic-helper";

import {
  shouldShowTerm,
  shouldShowPercent,
  shouldShowOpenPeriod,
  shouldShowAggregateInterestMethodId,
  shouldShowAggregateInterestDefinedAmt,
  shouldShowAggregateInterestMonthsOfInterest,
  shouldShowForYmYmaMw,
  shouldShowSMPVfields
} from "./loan-prepayment-schedule-logic";

const DEFAULT_WIDTH = 138;

export const rows = isQuote => ({
  term: {
    isVisible: data => shouldShowTerm(data, isQuote),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Term (m)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "term"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  percent: {
    isVisible: data => shouldShowPercent(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Minimum Prepayment",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: data => defaultPercentField(data, "percent", 100),
        Cell: tableSideColumnMapper,
        decimals: 3
      }
    ]
  },
  openPeriod: {
    isVisible: data => shouldShowOpenPeriod(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Open Periods",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "openPeriod"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  replacementRateSpread: {
    isVisible: data => shouldShowForYmYmaMw(data) || shouldShowSMPVfields(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Replacement Rate Spread (bps)",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => `${defaultField(data, "replacementRateSpread")}`,
        Cell: tableSideColumnMapper,
        decimals: 3
      }
    ]
  },
  lookback: {
    isVisible: data => shouldShowForYmYmaMw(data) || shouldShowSMPVfields(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Replacement Rate Lookback",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "lookbackDays"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  rounding: {
    isVisible: data => shouldShowForYmYmaMw(data) || shouldShowSMPVfields(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Replacement Rate Rounding",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "rounding.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  aggregateInterestMethodId: {
    isVisible: data => shouldShowAggregateInterestMethodId(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Aggregate Interest Method",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "aggregateInterestMethod.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  aggregateInterestDefinedAmt: {
    isVisible: data => shouldShowAggregateInterestDefinedAmt(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Prepayment Amount",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR,
        map: data => defaultField(data, "aggregateInterestDefinedAmt"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  aggregateInterestMonthsOfInterest: {
    isVisible: data => shouldShowAggregateInterestMonthsOfInterest(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Months of Interest",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "aggregateInterestMonthsOfInterest"),
        Cell: tableSideColumnMapper
      }
    ]
  }
});
